export interface CountryType {
	label: string
	code: string
	value: string
}

export const countries: CountryType[] = [
	{ code: 'US', label: 'United States', value: 'united states' },
	{ code: 'CA', label: 'Canada', value: 'canada' },
	{ code: 'IN', label: 'India', value: 'india' },
	{ code: 'AF', label: 'Afghanistan', value: 'afghanistan' },
	{ code: 'AL', label: 'Albania', value: 'albania' },
	{ code: 'DZ', label: 'Algeria', value: 'algeria' },
	{ code: 'AS', label: 'American Samoa', value: 'american samoa' },
	{ code: 'AD', label: 'Andorra', value: 'andorra' },
	{ code: 'AO', label: 'Angola', value: 'angola' },
	{ code: 'AI', label: 'Anguilla', value: 'anguilla' },
	{ code: 'AG', label: 'Antigua and Barbuda', value: 'antigua and barbuda' },
	{ code: 'AR', label: 'Argentina', value: 'argentina' },
	{ code: 'AM', label: 'Armenia', value: 'armenia' },
	{ code: 'AW', label: 'Aruba', value: 'aruba' },
	{ code: 'AU', label: 'Australia', value: 'australia' },
	{ code: 'AT', label: 'Austria', value: 'austria' },
	{ code: 'AZ', label: 'Azerbaijan', value: 'azerbaijan' },
	{ code: 'BS', label: 'Bahamas', value: 'bahamas' },
	{ code: 'BH', label: 'Bahrain', value: 'bahrain' },
	{ code: 'BD', label: 'Bangladesh', value: 'bangladesh' },
	{ code: 'BB', label: 'Barbados', value: 'barbados' },
	{ code: 'BY', label: 'Belarus', value: 'belarus' },
	{ code: 'BE', label: 'Belgium', value: 'belgium' },
	{ code: 'BZ', label: 'Belize', value: 'belize' },
	{ code: 'BJ', label: 'Benin', value: 'benin' },
	{ code: 'BM', label: 'Bermuda', value: 'bermuda' },
	{ code: 'BT', label: 'Bhutan', value: 'bhutan' },
	{
		code: 'BO',
		label: 'Bolivia, Plurinational State of',
		value: 'bolivia, plurinational state of',
	},
	{ code: 'BA', label: 'Bosnia and Herzegovina', value: 'bosnia and herzegovina' },
	{ code: 'BW', label: 'Botswana', value: 'botswana' },
	{ code: 'BR', label: 'Brazil', value: 'brazil' },
	{ code: 'IO', label: 'British Indian Ocean Territory', value: 'british indian ocean territory' },
	{ code: 'BG', label: 'Bulgaria', value: 'bulgaria' },
	{ code: 'BF', label: 'Burkina Faso', value: 'burkina faso' },
	{ code: 'BI', label: 'Burundi', value: 'burundi' },
	{ code: 'KH', label: 'Cambodia', value: 'cambodia' },
	{ code: 'CM', label: 'Cameroon', value: 'cameroon' },
	{ code: 'CV', label: 'Cape Verde', value: 'cape verde' },
	{ code: 'KY', label: 'Cayman Islands', value: 'cayman islands' },
	{ code: 'CF', label: 'Central African Republic', value: 'central african republic' },
	{ code: 'TD', label: 'Chad', value: 'chad' },
	{ code: 'CL', label: 'Chile', value: 'chile' },
	{ code: 'CN', label: 'China', value: 'china' },
	{ code: 'CO', label: 'Colombia', value: 'colombia' },
	{ code: 'KM', label: 'Comoros', value: 'comoros' },
	{ code: 'CG', label: 'Congo', value: 'congo' },
	{
		code: 'CD',
		label: 'Democratic Republic of the Congo',
		value: 'democratic republic of the congo',
	},
	{ code: 'CK', label: 'Cook Islands', value: 'cook islands' },
	{ code: 'CR', label: 'Costa Rica', value: 'costa rica' },
	{ code: 'CI', label: "Côte d'Ivoire", value: "côte d'ivoire" },
	{ code: 'HR', label: 'Croatia', value: 'croatia' },
	{ code: 'CU', label: 'Cuba', value: 'cuba' },
	{ code: 'CW', label: 'Curaçao', value: 'curaçao' },
	{ code: 'CY', label: 'Cyprus', value: 'cyprus' },
	{ code: 'CZ', label: 'Czech Republic', value: 'czech republic' },
	{ code: 'DK', label: 'Denmark', value: 'denmark' },
	{ code: 'DJ', label: 'Djibouti', value: 'djibouti' },
	{ code: 'DM', label: 'Dominica', value: 'dominica' },
	{ code: 'DO', label: 'Dominican Republic', value: 'dominican republic' },
	{ code: 'EC', label: 'Ecuador', value: 'ecuador' },
	{ code: 'EG', label: 'Egypt', value: 'egypt' },
	{ code: 'SV', label: 'El Salvador', value: 'el salvador' },
	{ code: 'GQ', label: 'Equatorial Guinea', value: 'equatorial guinea' },
	{ code: 'ER', label: 'Eritrea', value: 'eritrea' },
	{ code: 'EE', label: 'Estonia', value: 'estonia' },
	{ code: 'ET', label: 'Ethiopia', value: 'ethiopia' },
	{ code: 'FK', label: 'Falkland Islands (Malvinas)', value: 'falkland islands (malvinas)' },
	{ code: 'FO', label: 'Faroe Islands', value: 'faroe islands' },
	{ code: 'FJ', label: 'Fiji', value: 'fiji' },
	{ code: 'FI', label: 'Finland', value: 'finland' },
	{ code: 'FR', label: 'France', value: 'france' },
	{ code: 'PF', label: 'French Polynesia', value: 'french polynesia' },
	{ code: 'GA', label: 'Gabon', value: 'gabon' },
	{ code: 'GM', label: 'Gambia', value: 'gambia' },
	{ code: 'GE', label: 'Georgia', value: 'georgia' },
	{ code: 'DE', label: 'Germany', value: 'germany' },
	{ code: 'GH', label: 'Ghana', value: 'ghana' },
	{ code: 'GI', label: 'Gibraltar', value: 'gibraltar' },
	{ code: 'GR', label: 'Greece', value: 'greece' },
	{ code: 'GL', label: 'Greenland', value: 'greenland' },
	{ code: 'GD', label: 'Grenada', value: 'grenada' },
	{ code: 'GU', label: 'Guam', value: 'guam' },
	{ code: 'GT', label: 'Guatemala', value: 'guatemala' },
	{ code: 'GG', label: 'Guernsey', value: 'guernsey' },
	{ code: 'GN', label: 'Guinea', value: 'guinea' },
	{ code: 'GW', label: 'Guinea-Bissau', value: 'guinea-bissau' },
	{ code: 'HT', label: 'Haiti', value: 'haiti' },
	{ code: 'HN', label: 'Honduras', value: 'honduras' },
	{ code: 'HK', label: 'Hong Kong', value: 'hong kong' },
	{ code: 'HU', label: 'Hungary', value: 'hungary' },
	{ code: 'IS', label: 'Iceland', value: 'iceland' },
	{ code: 'ID', label: 'Indonesia', value: 'indonesia' },
	{ code: 'IR', label: 'Iran, Islamic Republic of', value: 'iran, islamic republic of' },
	{ code: 'IQ', label: 'Iraq', value: 'iraq' },
	{ code: 'IE', label: 'Ireland', value: 'ireland' },
	{ code: 'IM', label: 'Isle of Man', value: 'isle of man' },
	{ code: 'IL', label: 'Israel', value: 'israel' },
	{ code: 'IT', label: 'Italy', value: 'italy' },
	{ code: 'JM', label: 'Jamaica', value: 'jamaica' },
	{ code: 'JP', label: 'Japan', value: 'japan' },
	{ code: 'JE', label: 'Jersey', value: 'jersey' },
	{ code: 'JO', label: 'Jordan', value: 'jordan' },
	{ code: 'KZ', label: 'Kazakhstan', value: 'kazakhstan' },
	{ code: 'KE', label: 'Kenya', value: 'kenya' },
	{ code: 'KI', label: 'Kiribati', value: 'kiribati' },
	{ code: 'KP', label: 'North Korea', value: 'north korea' },
	{ code: 'KR', label: 'South Korea', value: 'south korea' },
	{ code: 'KW', label: 'Kuwait', value: 'kuwait' },
	{ code: 'KG', label: 'Kyrgyzstan', value: 'kyrgyzstan' },
	{
		code: 'LA',
		label: "Lao People's Democratic Republic",
		value: "lao people's democratic republic",
	},
	{ code: 'LV', label: 'Latvia', value: 'latvia' },
	{ code: 'LB', label: 'Lebanon', value: 'lebanon' },
	{ code: 'LS', label: 'Lesotho', value: 'lesotho' },
	{ code: 'LR', label: 'Liberia', value: 'liberia' },
	{ code: 'LY', label: 'Libya', value: 'libya' },
	{ code: 'LI', label: 'Liechtenstein', value: 'liechtenstein' },
	{ code: 'LT', label: 'Lithuania', value: 'lithuania' },
	{ code: 'LU', label: 'Luxembourg', value: 'luxembourg' },
	{ code: 'MO', label: 'Macao', value: 'macao' },
	{ code: 'MK', label: 'Republic of Macedonia', value: 'republic of macedonia' },
	{ code: 'MG', label: 'Madagascar', value: 'madagascar' },
	{ code: 'MW', label: 'Malawi', value: 'malawi' },
	{ code: 'MY', label: 'Malaysia', value: 'malaysia' },
	{ code: 'MV', label: 'Maldives', value: 'maldives' },
	{ code: 'ML', label: 'Mali', value: 'mali' },
	{ code: 'MT', label: 'Malta', value: 'malta' },
	{ code: 'MH', label: 'Marshall Islands', value: 'marshall islands' },
	{ code: 'MQ', label: 'Martinique', value: 'martinique' },
	{ code: 'MR', label: 'Mauritania', value: 'mauritania' },
	{ code: 'MU', label: 'Mauritius', value: 'mauritius' },
	{ code: 'MX', label: 'Mexico', value: 'mexico' },
	{
		code: 'FM',
		label: 'Micronesia, Federated States of',
		value: 'micronesia, federated states of',
	},
	{ code: 'MD', label: 'Republic of Moldova', value: 'republic of moldova' },
	{ code: 'MC', label: 'Monaco', value: 'monaco' },
	{ code: 'MN', label: 'Mongolia', value: 'mongolia' },
	{ code: 'ME', label: 'Montenegro', value: 'montenegro' },
	{ code: 'MS', label: 'Montserrat', value: 'montserrat' },
	{ code: 'MA', label: 'Morocco', value: 'morocco' },
	{ code: 'MZ', label: 'Mozambique', value: 'mozambique' },
	{ code: 'MM', label: 'Myanmar', value: 'myanmar' },
	{ code: 'NA', label: 'Namibia', value: 'namibia' },
	{ code: 'NR', label: 'Nauru', value: 'nauru' },
	{ code: 'NP', label: 'Nepal', value: 'nepal' },
	{ code: 'NL', label: 'Netherlands', value: 'netherlands' },
	{ code: 'NZ', label: 'New Zealand', value: 'new zealand' },
	{ code: 'NI', label: 'Nicaragua', value: 'nicaragua' },
	{ code: 'NE', label: 'Niger', value: 'niger' },
	{ code: 'NG', label: 'Nigeria', value: 'nigeria' },
	{ code: 'NU', label: 'Niue', value: 'niue' },
	{ code: 'NF', label: 'Norfolk Island', value: 'norfolk island' },
	{ code: 'MP', label: 'Northern Mariana Islands', value: 'northern mariana islands' },
	{ code: 'NO', label: 'Norway', value: 'norway' },
	{ code: 'OM', label: 'Oman', value: 'oman' },
	{ code: 'PK', label: 'Pakistan', value: 'pakistan' },
	{ code: 'PW', label: 'Palau', value: 'palau' },
	{ code: 'PS', label: 'Palestinian Territory', value: 'palestinian territory' },
	{ code: 'PA', label: 'Panama', value: 'panama' },
	{ code: 'PG', label: 'Papua New Guinea', value: 'papua new guinea' },
	{ code: 'PY', label: 'Paraguay', value: 'paraguay' },
	{ code: 'PE', label: 'Peru', value: 'peru' },
	{ code: 'PH', label: 'Philippines', value: 'philippines' },
	{ code: 'PN', label: 'Pitcairn', value: 'pitcairn' },
	{ code: 'PL', label: 'Poland', value: 'poland' },
	{ code: 'PT', label: 'Portugal', value: 'portugal' },
	{ code: 'PR', label: 'Puerto Rico', value: 'puerto rico' },
	{ code: 'QA', label: 'Qatar', value: 'qatar' },
	{ code: 'RO', label: 'Romania', value: 'romania' },
	{ code: 'RU', label: 'Russia', value: 'russia' },
	{ code: 'RW', label: 'Rwanda', value: 'rwanda' },
	{ code: 'KN', label: 'Saint Kitts and Nevis', value: 'saint kitts and nevis' },
	{ code: 'LC', label: 'Saint Lucia', value: 'saint lucia' },
	{ code: 'WS', label: 'Samoa', value: 'samoa' },
	{ code: 'SM', label: 'San Marino', value: 'san marino' },
	{ code: 'ST', label: 'Sao Tome and Principe', value: 'sao tome and principe' },
	{ code: 'SA', label: 'Saudi Arabia', value: 'saudi arabia' },
	{ code: 'SN', label: 'Senegal', value: 'senegal' },
	{ code: 'RS', label: 'Serbia', value: 'serbia' },
	{ code: 'SC', label: 'Seychelles', value: 'seychelles' },
	{ code: 'SL', label: 'Sierra Leone', value: 'sierra leone' },
	{ code: 'SG', label: 'Singapore', value: 'singapore' },
	{ code: 'SX', label: 'Sint Maarten', value: 'sint maarten' },
	{ code: 'SK', label: 'Slovakia', value: 'slovakia' },
	{ code: 'SI', label: 'Slovenia', value: 'slovenia' },
	{ code: 'SB', label: 'Solomon Islands', value: 'solomon islands' },
	{ code: 'SO', label: 'Somalia', value: 'somalia' },
	{ code: 'ZA', label: 'South Africa', value: 'south africa' },
	{ code: 'SS', label: 'South Sudan', value: 'south sudan' },
	{ code: 'ES', label: 'Spain', value: 'spain' },
	{ code: 'LK', label: 'Sri Lanka', value: 'sri lanka' },
	{ code: 'SD', label: 'Sudan', value: 'sudan' },
	{ code: 'SR', label: 'Suriname', value: 'suriname' },
	{ code: 'SZ', label: 'Swaziland', value: 'swaziland' },
	{ code: 'SE', label: 'Sweden', value: 'sweden' },
	{ code: 'CH', label: 'Switzerland', value: 'switzerland' },
	{ code: 'SY', label: 'Syria', value: 'syria' },
	{ code: 'TW', label: 'Taiwan', value: 'taiwan' },
	{ code: 'TJ', label: 'Tajikistan', value: 'tajikistan' },
	{ code: 'TZ', label: 'Tanzania', value: 'tanzania' },
	{ code: 'TH', label: 'Thailand', value: 'thailand' },
	{ code: 'TG', label: 'Togo', value: 'togo' },
	{ code: 'TK', label: 'Tokelau', value: 'tokelau' },
	{ code: 'TO', label: 'Tonga', value: 'tonga' },
	{ code: 'TT', label: 'Trinidad and Tobago', value: 'trinidad and tobago' },
	{ code: 'TN', label: 'Tunisia', value: 'tunisia' },
	{ code: 'TR', label: 'Turkey', value: 'turkey' },
	{ code: 'TM', label: 'Turkmenistan', value: 'turkmenistan' },
	{ code: 'TC', label: 'Turks and Caicos Islands', value: 'turks and caicos islands' },
	{ code: 'TV', label: 'Tuvalu', value: 'tuvalu' },
	{ code: 'UG', label: 'Uganda', value: 'uganda' },
	{ code: 'UA', label: 'Ukraine', value: 'ukraine' },
	{ code: 'AE', label: 'United Arab Emirates', value: 'united arab emirates' },
	{ code: 'GB', label: 'United Kingdom', value: 'united kingdom' },
	{ code: 'UY', label: 'Uruguay', value: 'uruguay' },
	{ code: 'UZ', label: 'Uzbekistan', value: 'uzbekistan' },
	{ code: 'VU', label: 'Vanuatu', value: 'vanuatu' },
	{
		code: 'VE',
		label: 'Venezuela, Bolivarian Republic of',
		value: 'venezuela, bolivarian republic of',
	},
	{ code: 'VN', label: 'Viet Nam', value: 'viet nam' },
	{ code: 'VI', label: 'Virgin Islands', value: 'virgin islands' },
	{ code: 'YE', label: 'Yemen', value: 'yemen' },
	{ code: 'ZM', label: 'Zambia', value: 'zambia' },
	{ code: 'ZW', label: 'Zimbabwe', value: 'zimbabwe' },
]
